module.exports = __webpack_public_path__ + "static/media/e-sports2.21c03129.jpg";